import { api } from 'src/api/axios';

export interface UserResponse {
  id: unknown;
  createdAt: string;
  updatedAt: string;
  firstName: string;
  lastName: string;
  midName: string;
  email: string;
  phone: string;
  role: number;
  status: number;
}

export interface CreateUserRequest {
  groupHash?: string;
  firstName?: string;
  lastName?: string;
  midName?: string;
  email?: string;
  phone?: string;
  password?: string;
  role?: number;
  status?: number;
}

export interface UpdateUserRequest {
  firstName?: string;
  lastName?: string;
  midName?: string;
  email?: string;
  phone?: string;
  role?: number;
  status?: number;
}

export interface UpdatePasswordRequest {
  password: string;
}

export interface UpdateAddressRequest {
  address1?: string;
  address2?: string;
  city?: string;
  state?: string;
  zipcode?: string;
  country?: string;
}

export interface UserListResponse {
  data: UserResponse[];
  pagination: {
    hasNextPage: boolean;
    total: number;
  };
}

export const usersService = {
  list: async (params?: {
    usersOnly?: boolean;
    adminsOnly?: boolean;
    search?: string;
    offset?: number;
    limit?: number;
    column?: 'firstName' | 'lastName' | 'midName' | 'email' | 'role' | 'status' | 'createdAt' | 'updatedAt';
    order?: 'asc' | 'desc';
  }): Promise<UserListResponse> => {
    const query: any = { ...params };
    if (query && typeof query.search === 'string' && query.search.trim().length < 2) {
      delete query.search;
    }
    const res = await api.get('/users', { params: query });
    return res.data;
  },
  create: async (payload: CreateUserRequest): Promise<UserResponse> => {
    const res = await api.post('/users', payload);
    return res.data;
  },
  getOne: async (id: string | number): Promise<UserResponse> => {
    const res = await api.get(`/users/${id}`);
    return res.data;
  },
  update: async (id: string | number, payload: UpdateUserRequest): Promise<UserResponse> => {
    const res = await api.patch(`/users/${id}`, payload);
    return res.data;
  },
  remove: async (id: string | number): Promise<void> => {
    await api.delete(`/users/${id}`);
  },
  updatePassword: async (id: string | number, payload: UpdatePasswordRequest): Promise<void> => {
    await api.patch(`/users/${id}/password`, payload);
  },
  updateAddress: async (id: string | number, payload: UpdateAddressRequest): Promise<void> => {
    await api.patch(`/users/${id}/address`, payload);
  },
};


